import React from "react";
import { useState } from "react";

const FileUpload = ({ handleUpload, onContinue, hideContinue }) => {
    const [disabled, setDisabled] = useState(true)
    const [isDragging, setIsDragging] = useState(false)

    const onUpload = (e) => {
        setDisabled(false)
        handleUpload(e)
    }

    const onDragOver = (e) => {
        e.preventDefault()
        setIsDragging(true)
    }

    const onDragLeave = (e) => {
        e.preventDefault()
        setIsDragging(false)
    }

    const onDrop = (e) => {
        e.preventDefault()
        setIsDragging(false)

        const files = e.dataTransfer.files
        if (!files?.length) return

        setDisabled(false)
        handleUpload({ preventDefault: () => {}, target: { files } })
    }

    return (
        <form method="post" className="upload">
            <article
                className={`drop-zone${isDragging ? ' drag-over' : ''}`}
                onDragOver={onDragOver}
                onDragLeave={onDragLeave}
                onDrop={onDrop}
            >
                <label htmlFor="inputTag" className={isDragging ? 'drag-over' : ''}>
                    <img src="./svg/upload.svg" alt="upload files" />
                    {isDragging ? 'Drop files' : 'Upload file'}
                    <input onChange={onUpload} multiple id="inputTag" type="file"/>
                </label>
            </article>
            {!hideContinue && <button style={{visibility: 'hidden'}} onClick={onContinue} className={`${disabled ? 'disabled' : null}`}>Continue</button>}
        </form>
    )
}

export default FileUpload
